export const AllTests=()=>{
    return (<h2>All Testimonial Data Data</h2>);
}

